import CustomBracketSetsApiService from '../services/api/customBracketSets';
import { enqueueNotification } from './notifications';

const FETCH_CUSTOM_BRACKET_SETS_REQUEST = 'FETCH_CUSTOM_BRACKET_SETS_REQUEST';
const FETCH_CUSTOM_BRACKET_SETS_SUCCESS = 'FETCH_CUSTOM_BRACKET_SETS_SUCCESS';
const FETCH_CUSTOM_BRACKET_SETS_FAILED = 'FETCH_CUSTOM_BRACKET_SETS_FAILED';

const SET_CUSTOM_BRACKET_SET = 'SET_CUSTOM_BRACKET_SET';

const CREATE_CUSTOM_BRACKET_SET_REQUEST = 'CREATE_CUSTOM_BRACKET_SET_REQUEST';
const CREATE_CUSTOM_BRACKET_SET_SUCCESS = 'CREATE_CUSTOM_BRACKET_SET_SUCCESS';
const CREATE_CUSTOM_BRACKET_SET_FAILED = 'CREATE_CUSTOM_BRACKET_SET_FAILED';

const UPDATE_CUSTOM_BRACKET_SET_REQUEST = 'UPDATE_CUSTOM_BRACKET_SET_REQUEST';
const UPDATE_CUSTOM_BRACKET_SET_SUCCESS = 'UPDATE_CUSTOM_BRACKET_SET_SUCCESS';
const UPDATE_CUSTOM_BRACKET_SET_FAILED = 'UPDATE_CUSTOM_BRACKET_SET_FAILED';

const DELETE_CUSTOM_BRACKET_SET_REQUEST = 'DELETE_CUSTOM_BRACKET_SET_REQUEST';
const DELETE_CUSTOM_BRACKET_SET_SUCCESS = 'DELETE_CUSTOM_BRACKET_SET_SUCCESS';
const DELETE_CUSTOM_BRACKET_SET_FAILED = 'DELETE_CUSTOM_BRACKET_SET_FAILED';

const RESET_CUSTOM_BRACKET_SETS = 'RESET_CUSTOM_BRACKET_SETS';

const OPEN_CUSTOM_BRACKET_SET_FORM = 'OPEN_CUSTOM_BRACKET_SET_FORM';
const CLOSE_CUSTOM_BRACKET_SET_FORM = 'CLOSE_CUSTOM_BRACKET_SET_FORM';

const initialState = {
  form: {
    data: null,
    saving: false
  },
  deleting: false,
  parameters: {
    order: 'asc',
    orderBy: 'name',
    assignedToUserId: null,
    perPage: 10,
    page: 1
  },
  list: {
    organizationId: null,
    initialized: false,
    failed: false,
    data: []
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOM_BRACKET_SETS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          organizationId: action.payload.organizationId,
          loading: true
        },
        parameters: {
          ...initialState.parameters,
          ...action.payload.params
        }
      };
    case FETCH_CUSTOM_BRACKET_SETS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data,
          total: action.payload.total,
          loading: false,
          initialized: true,
          failed: false
        }
      };
    case FETCH_CUSTOM_BRACKET_SETS_FAILED:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          initialized: true,
          failed: true
        }
      };
    case RESET_CUSTOM_BRACKET_SETS:
      return {
        ...initialState
      };
    case SET_CUSTOM_BRACKET_SET:
      return {
        ...state,
        form: {
          data: action.payload.data,
          loading: false,
          saving: false
        }
      };
    case CREATE_CUSTOM_BRACKET_SET_REQUEST:
      return {
        ...state,
        form: {
          ...state.form,
          saving: true
        }
      };
    case CREATE_CUSTOM_BRACKET_SET_SUCCESS:
      return {
        ...state,
        form: {
          data: action.payload.data,
          saving: false
        }
      };
    case CREATE_CUSTOM_BRACKET_SET_FAILED:
    case UPDATE_CUSTOM_BRACKET_SET_FAILED:
      return {
        ...state,
        form: {
          ...state.form,
          saving: false
        }
      };
    case UPDATE_CUSTOM_BRACKET_SET_REQUEST:
      return {
        ...state,
        form: {
          ...state.form,
          saving: true
        }
      };
    case UPDATE_CUSTOM_BRACKET_SET_SUCCESS:
      return {
        ...state,
        form: {
          data: action.payload.data,
          saving: false
        },
        list: {
          ...state.list,
          data: state.list.data.map(item =>
            item.id === action.payload.data.id ? action.payload.data : item
          )
        }
      };
    case DELETE_CUSTOM_BRACKET_SET_REQUEST:
      return {
        ...state,
        deleting: true
      };
    case DELETE_CUSTOM_BRACKET_SET_SUCCESS:
      return {
        ...state,
        form: initialState.form,
        deleting: false,
        list: {
          ...state.list,
          data: state.list.data.filter(item => item.id !== action.payload.id),
          total: state.list.total - 1
        }
      };
    case DELETE_CUSTOM_BRACKET_SET_FAILED:
      return {
        ...state,
        deleting: false
      };
    case OPEN_CUSTOM_BRACKET_SET_FORM:
      return {
        ...state,
        form: {
          data: action.payload.data || null,
          saving: false
        }
      };
    case CLOSE_CUSTOM_BRACKET_SET_FORM:
      return {
        ...state,
        form: initialState.form
      };
    default:
      return state;
  }
};

// Action Creators
export const fetchCustomBracketSetsAction = (organizationId, params = {}) => {
  return dispatch => {
    dispatch({ type: FETCH_CUSTOM_BRACKET_SETS_REQUEST, payload: { organizationId, params } });
    // Call API service to fetch custom bracket sets
    // Assuming apiService is an instance of CustomBracketSets API service
    const apiService = new CustomBracketSetsApiService();
    return apiService
      .get(organizationId, params)
      .then(response => {
        dispatch({
          type: FETCH_CUSTOM_BRACKET_SETS_SUCCESS,
          payload: {
            data: response.data,
            total: response.meta.total
          }
        });
      })
      .catch(error => {
        dispatch({ type: FETCH_CUSTOM_BRACKET_SETS_FAILED });
        dispatch(enqueueNotification('error', error.message));
      });
  };
};

export const refreshCustomBracketSetsAction = organizationId => {
  return (dispatch, getState) => {
    const { parameters } = getState().customBracketSets;
    return dispatch(fetchCustomBracketSetsAction(organizationId, parameters));
  };
};

export const clearCustomBracketSetsAction = () => {
  return dispatch => {
    dispatch({ type: RESET_CUSTOM_BRACKET_SETS });
  };
};

export const createCustomBracketSetAction = (organizationId, data) => {
  return dispatch => {
    dispatch({ type: CREATE_CUSTOM_BRACKET_SET_REQUEST });
    const apiService = new CustomBracketSetsApiService();
    return new Promise((resolve, reject) => {
      apiService
        .create(organizationId, data)
        .then(response => {
          dispatch({
            type: CREATE_CUSTOM_BRACKET_SET_SUCCESS,
            payload: { data: response.data }
          });
          dispatch(refreshCustomBracketSetsAction(organizationId));
          dispatch(enqueueNotification('success', 'Custom bracket set created successfully.'));

          resolve();
        })
        .catch(error => {
          dispatch(enqueueNotification('error', error.message));
          dispatch({ type: CREATE_CUSTOM_BRACKET_SET_FAILED });
          reject();
        });
    });
  };
};

export const updateCustomBracketSetAction = (organizationId, id, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: UPDATE_CUSTOM_BRACKET_SET_REQUEST });
      const apiService = new CustomBracketSetsApiService();
      apiService
        .update(organizationId, id, data)
        .then(response => {
          dispatch({
            type: UPDATE_CUSTOM_BRACKET_SET_SUCCESS,
            payload: { data: response.data }
          });
          dispatch(enqueueNotification('success', 'Custom bracket set updated successfully.'));
          resolve(response.data);
        })
        .catch(error => {
          dispatch({ type: UPDATE_CUSTOM_BRACKET_SET_FAILED });
          dispatch(enqueueNotification('error', error.message));
          reject();
        });
    });
  };
};

export const openCustomBracketSetForm = data => {
  return dispatch => {
    dispatch({
      type: OPEN_CUSTOM_BRACKET_SET_FORM,
      payload: { data }
    });
  };
};
export const closeCustomBracketSetForm = () => {
  return dispatch => {
    dispatch({
      type: CLOSE_CUSTOM_BRACKET_SET_FORM
    });
  };
};

export const deleteCustomBracketSetAction = (organizationId, id) => {
  return dispatch => {
    dispatch({ type: DELETE_CUSTOM_BRACKET_SET_REQUEST });
    const apiService = new CustomBracketSetsApiService();
    return new Promise((resolve, reject) => {
      apiService
        .delete(organizationId, id)
        .then(() => {
          dispatch({
            type: DELETE_CUSTOM_BRACKET_SET_SUCCESS,
            payload: { id }
          });
          dispatch(refreshCustomBracketSetsAction(organizationId));
          dispatch(enqueueNotification('success', 'Custom bracket set deleted successfully.'));
          resolve();
        })
        .catch(error => {
          dispatch({ type: DELETE_CUSTOM_BRACKET_SET_FAILED });
          const message = error.responseData?.message || error.message;
          dispatch(enqueueNotification('error', message));
          reject();
        });
    });
  };
};
